import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'
import VendorCardGrid from '../atoms/vendor-card/VendorCardGrid'
import styles from './venderListStyle.module.scss'

const VenderGridView = ({type}) => {
	const vendors = useSelector((s) => s.vendor.vendorSearchList)
	return (
		<div className={styles.venderListView}>
			<Grid container spacing={2}>
				{vendors?.length > 0 &&
					vendors.map((item) => (
						<Grid
							size={{ xs: 12, sm: 6, md: 6, lg: 4 }}
							key={item._id}
						>
							<VendorCardGrid data={item} type={type}/>
						</Grid>
					))}
			</Grid>
		</div>
	)
}

export default VenderGridView
